import httpAuth from "@/common/http/http-common";
import { CheckoutRequestDto, StripeInfoDto, StripePaymentMethodFormDto } from "@/types/stripe.type";

class StripeService {
  client = httpAuth("stripe");

  async createCheckoutSession(request: CheckoutRequestDto): Promise<string> {
    const { data } = await this.client.post("checkout-session/create", request);

    return data;
  }

  async getInfo(officeId: number, productId: string): Promise<StripeInfoDto> {
    const { data } = await this.client.get(`office/${officeId}/info?productId=${productId}`);

    return data;
  }

  async savePaymentMethod(form: StripePaymentMethodFormDto): Promise<void> {
    await this.client.post("payment-method", form);
  }

  async getPaymentMethodForm(id: string): Promise<StripePaymentMethodFormDto> {
    const { data } = await this.client.get(`payment-method/${id}/form`);

    return data;
  }

  async cancelSubscription(subscriptionId: string, officeId: number): Promise<void> {
    await this.client.post(`subscription/${subscriptionId}/office/${officeId}/cancel`);
  }

  async renewSubscription(subscriptionId: string, officeId: number): Promise<void> {
    await this.client.post(`subscription/${subscriptionId}/office/${officeId}/renew`);
  }
}

export default new StripeService();